<template>
  <div
    class="loading-overlay"
    :style="[size ? { '--spinner-size': size } : null]"
  >
    <div class="loading-overlay-inner">
      <LoadingAnimation />
    </div>
  </div>
</template>

<script>
import LoadingAnimation from './LoadingAnimation'

export default {
  components: { LoadingAnimation },
  props: {
    size: Number,
  },
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  $loadingOverlayTransitionTiming: 0.3s;
  --spinner-size: 3;

  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  font-size: calc(var(--spinner-size) * 1em);
  background: rgba($frameBackgroundColor, 0.5);
  transition: opacity $loadingOverlayTransitionTiming ease-out;

  > .loading-overlay-inner {
    transition: transform $loadingOverlayTransitionTiming ease-out;
  }

  &[hidden] {
    opacity: 0;
    pointer-events: none;

    > .loading-overlay-inner {
      transform: scale(1.5);
    }
  }
}
</style>
